
export function nameOf<T>(key: keyof T): keyof T {
  return key;
}

export function isNonNullable<T>(item: T): item is NonNullable<T> {
  return !!item;
}
